"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Player = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _classnames10 = _interopRequireDefault(require("classnames"));
var _settings = require("./settings.js");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _striptags = _interopRequireDefault(require("striptags"));
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate.js"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _cccisdResponsive = _interopRequireDefault(require("cccisd-responsive"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/svg/checkmark"));
var _IconCorrect = _interopRequireDefault(require("./IconCorrect"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross4"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var count = 1;
var Player = exports.Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);
  function Player() {
    var _this;
    _classCallCheck(this, Player);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Player, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getFieldValue", function () {
      return (0, _settings.processValue)(_this.props.field.value);
    });
    _defineProperty(_assertThisInitialized(_this), "hasAnswer", function () {
      return _this.getFieldValue().selected.length > 0;
    });
    _defineProperty(_assertThisInitialized(_this), "pickOne", function (id) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _this._onChange(!_this.getFieldValue().selected.includes(id) || force ? [id] : []);
    });
    _defineProperty(_assertThisInitialized(_this), "pickMultiple", function (id) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var settings = _this.props.settings;
      var exclusiveOptions = settings.optionTypes["static"].filter(function (item) {
        return item.isExclusive;
      }).map(function (item) {
        return item.id;
      });
      var value = _this.getFieldValue().selected || [];
      if (exclusiveOptions.includes(id)) {
        _this._onChange(!value.includes(id) || force ? [id] : []);
      } else {
        _this._onChange(value.includes(id) ? value.filter(function (item) {
          return item !== id || force;
        }) : [].concat(_toConsumableArray(value.filter(function (item) {
          return !exclusiveOptions.includes(item);
        })), [id]));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getCorrectOptions", function () {
      var _this$props$settings = _this.props.settings,
        hasCorrectAnswers = _this$props$settings.hasCorrectAnswers,
        correctAnswers = _this$props$settings.correctAnswers,
        options = _this$props$settings.options;
      var selected = (0, _get2["default"])(_assertThisInitialized(_this), 'props.field.value.selected', []);
      if (!_this.props.showCorrectnessFeedback || !hasCorrectAnswers || !correctAnswers || !selected) {
        return [];
      }
      var result = (0, _intersection2["default"])(correctAnswers, selected);
      var _iterator = _createForOfIteratorHelper(options),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          if (!correctAnswers.includes(option.id) && !selected.includes(option.id)) {
            result.push(option.id);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "_registerAction", function (index, action) {
      _this.props.registerAction(index, action);
    });
    _defineProperty(_assertThisInitialized(_this), "_onChange", function (array) {
      // Return if it is a tree preview
      if (!_this.props.field.onChange) {
        return;
      }
      var value = _this.getFieldValue();
      var options = _this._getOptions();

      // don't include values without labels
      value.selected = _toConsumableArray(array).filter(function (id) {
        return options.find(function (item) {
          return item.id === id;
        });
      });
      var selectedLabels = {};
      options.forEach(function (option) {
        selectedLabels[option.id] = (0, _cccisdSurveyCommon.stripTags)(option.label);
      });
      _this.props.field.onChange(_objectSpread(_objectSpread({}, value), {}, {
        selectedLabels: selectedLabels,
        // we need count to trigger redux-form "validate" function
        // it's a hack.
        count: count++
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getOptions", function () {
      var _this$props$settings2 = _this.props.settings,
        options = _this$props$settings2.options,
        optionTypes = _this$props$settings2.optionTypes;

      // get static options
      var result = options.filter(function (item) {
        return item.type === 'static';
      });

      // get options from list
      options.filter(function (item) {
        return item.type === 'list';
      }).forEach(function (option) {
        var optionType = optionTypes.list.find(function (type) {
          return type.id === option.id;
        });

        // if it's in preview mode
        if (!(0, _isArray2["default"])(optionType.handle)) {
          result = [].concat(_toConsumableArray(result), [{
            id: option.id,
            label: "<span class=\"cccisd-wysiwyg-variable\">List \"".concat(option.label, "\"</span>")
          }]);
        } else {
          result = [].concat(_toConsumableArray(result), _toConsumableArray(optionType.handle.map(function (item) {
            return {
              id: "".concat(option.id, "_").concat(item.id),
              label: item.name
            };
          })));
        }
      });
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderRadioElement", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].radioNew
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].dot
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderCheckboxElement", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].checkboxNew
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].check
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderBigRadioElement", function (option) {
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames10["default"])(_style["default"].bigRadio, _defineProperty({}, _style["default"].active, _this.getFieldValue().selected.includes(option.id)))
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].hidden
      }, _this._renderRadioElement()));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderBigCheckbox", function (option) {
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames10["default"])(_style["default"].bigCheckbox, _defineProperty({}, _style["default"].active, _this.getFieldValue().selected.includes(option.id)))
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].hidden
      }, _this._renderCheckboxElement()));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderButtonElement", function (_ref) {
      var option = _ref.option,
        _ref$optionType = _ref.optionType,
        optionType = _ref$optionType === void 0 ? {} : _ref$optionType,
        index = _ref.index;
      var _this$props$settings3 = _this.props.settings,
        singleOrMultiple = _this$props$settings3.singleOrMultiple,
        verticalWidth = _this$props$settings3.verticalWidth,
        minButtonHeight = _this$props$settings3.minButtonHeight,
        buttonTextAlign = _this$props$settings3.buttonTextAlign,
        hasCorrectAnswers = _this$props$settings3.hasCorrectAnswers,
        correctAnswers = _this$props$settings3.correctAnswers;
      var accommodations = _objectSpread(_objectSpread({}, _this.props.accommodations), {}, {
        autoplayQuestions: false
      });
      var checked = _this.getFieldValue().selected.includes(option.id);
      var hasAnswer = _this.hasAnswer();
      var classes = singleOrMultiple === 'single' ? _defineProperty(_defineProperty({}, _style["default"].correct, _this.props.showCorrectnessFeedback && hasCorrectAnswers && correctAnswers && checked && correctAnswers.includes(option.id)), _style["default"].wrong, _this.props.showCorrectnessFeedback && hasCorrectAnswers && correctAnswers && checked && !correctAnswers.includes(option.id)) : {};
      var mapJustifyContentToTextAlign = {
        center: 'center',
        'flex-start': 'left',
        'flex-end': 'right'
      };
      var showCorrectAnswers = _this.props.showCorrectnessFeedback && hasCorrectAnswers && hasAnswer && singleOrMultiple === 'multiple';
      var isCorrectAnswer = showCorrectAnswers && correctAnswers.includes(option.id);
      return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        key: option.id,
        content: option.label,
        registerAction: _this._registerAction.bind(_assertThisInitialized(_this), index + 1),
        accommodations: accommodations,
        setParameters: _this.props.setParameters,
        allowMasking: true,
        render: function render(_ref3) {
          var html = _ref3.html,
            playAudio = _ref3.playAudio;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: (0, _classnames10["default"])('btn', 'btn-default', _objectSpread(_defineProperty(_defineProperty({
              'btn-primary active': checked
            }, _style["default"].checked, checked), _style["default"].hasCorrectAnswers, showCorrectAnswers), classes), _style["default"][verticalWidth], _style["default"].button),
            style: {
              minHeight: minButtonHeight,
              textAlign: mapJustifyContentToTextAlign[buttonTextAlign] || 'center',
              justifyContent: buttonTextAlign || 'center'
            },
            onClick: singleOrMultiple === 'single' ? function (event) {
              event.preventDefault();
              playAudio();
              _this.pickOne(option.id);
            } : function (event) {
              event.preventDefault();
              playAudio();
              _this.pickMultiple(option.id);
            },
            "data-option": option.id
          }, isCorrectAnswer && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].correctCheckmark
          }, /*#__PURE__*/_react["default"].createElement(_IconCorrect["default"], null)), html);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderDropdown", function () {
      var _this$props = _this.props,
        field = _this$props.field,
        isPrintMode = _this$props.isPrintMode;
      var _this$props$settings4 = _this.props.settings,
        dropdownZeroLabel = _this$props$settings4.dropdownZeroLabel,
        dropdownWidth = _this$props$settings4.dropdownWidth;
      var value = _this.getFieldValue().selected[0] || 0;
      var options = [{
        id: 0,
        label: dropdownZeroLabel
      }].concat(_toConsumableArray(_this._getOptions()));

      // Move selected option to the first in print mode
      // Otherwise it won't be shown in PDF
      if (isPrintMode) {
        options = [].concat(_toConsumableArray(options.filter(function (item) {
          return item.id === value;
        })), _toConsumableArray(options.filter(function (item) {
          return item.id !== value;
        })));
      }
      return /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _domOnlyProps["default"])(field), {
        value: value,
        onChange: function onChange(event) {
          if (event.target.value === '0') {
            _this._onChange([]);
          } else {
            _this._onChange([Number(event.target.value) || event.target.value]);
          }
        },
        onBlur: function onBlur() {},
        style: {
          width: dropdownWidth,
          maxWidth: '100%'
        }
      }), options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.id,
          value: option.id,
          dangerouslySetInnerHTML: {
            __html: (0, _striptags["default"])(option.label)
          }
        });
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderButton", function () {
      var _this$props$settings5 = _this.props.settings,
        hasCorrectAnswers = _this$props$settings5.hasCorrectAnswers,
        correctAnswers = _this$props$settings5.correctAnswers,
        singleOrMultiple = _this$props$settings5.singleOrMultiple,
        verticalWidth = _this$props$settings5.verticalWidth;
      var options = _this._getOptions();
      var hasAnswer = _this.hasAnswer();
      var showCorrectAnswers = _this.props.showCorrectnessFeedback && hasCorrectAnswers && hasAnswer && singleOrMultiple === 'multiple';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttonsVertical
      }, showCorrectAnswers && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames10["default"])(_style["default"].correctAnswers, _style["default"][verticalWidth])
      }, /*#__PURE__*/_react["default"].createElement("div", null, "Your answer", _this.getFieldValue().selected.length > 1 ? 's' : ''), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].label
      }, "Correct answer", correctAnswers.length > 1 ? 's' : '')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttons
      }, options.map(function (option, index) {
        var optionType = _this._getOptionTypeValue(option);
        return _this._renderButtonElement({
          option: option,
          optionType: optionType,
          index: index
        });
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_getOptionTypeValue", function (option) {
      var optionTypes = _this.props.settings.optionTypes;
      var types = optionTypes[option.type];
      if (!types) {
        return {};
      }
      return types.find(function (item) {
        return item.id === option.id;
      }) || {};
    });
    _defineProperty(_assertThisInitialized(_this), "_renderRadio", function () {
      var _this$props$settings6 = _this.props.settings,
        verticalOrHorizontal = _this$props$settings6.verticalOrHorizontal,
        verticalWidth = _this$props$settings6.verticalWidth,
        showLabelsInMatrixHeader = _this$props$settings6.showLabelsInMatrixHeader,
        hasCorrectAnswers = _this$props$settings6.hasCorrectAnswers,
        correctAnswers = _this$props$settings6.correctAnswers;
      var accommodations = _objectSpread(_objectSpread({}, _this.props.accommodations), {}, {
        autoplayQuestions: false
      });
      var options = _this._getOptions();
      var hasAnswer = _this.hasAnswer();
      if (_this.props.isMatrixMode && showLabelsInMatrixHeader) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].matrixValuesWrapper
        }, options.map(function (option, index) {
          return /*#__PURE__*/_react["default"].createElement("label", {
            key: option.id,
            className: _style["default"].matrixLabel,
            style: {
              width: "".concat(100 / options.length, "%")
            },
            onClick: function onClick() {
              return _this.pickOne(option.id);
            },
            "data-option": option.id
          }, _this._renderBigRadioElement(option), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].hiddenLabel
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: option.label
          })));
        }));
      }
      if (verticalOrHorizontal === 'horizontal') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].horizontalBlock
        }, options.map(function (option, index) {
          var checked = _this.getFieldValue().selected.includes(option.id);
          return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            key: option.id,
            content: option.label,
            registerAction: _this._registerAction.bind(_assertThisInitialized(_this), index + 1),
            setParameters: _this.props.setParameters,
            accommodations: accommodations,
            allowMasking: true,
            render: function render(_ref4) {
              var html = _ref4.html,
                playAudio = _ref4.playAudio;
              return /*#__PURE__*/_react["default"].createElement("div", {
                onClick: function onClick(event) {
                  event.preventDefault();
                  playAudio();
                  _this.pickOne(option.id);
                },
                className: (0, _classnames10["default"])(_style["default"].option, _defineProperty(_defineProperty(_defineProperty({}, _style["default"].checked, checked), _style["default"].correct, _this.props.showCorrectnessFeedback && hasCorrectAnswers && correctAnswers && checked && hasAnswer && correctAnswers.includes(option.id)), _style["default"].wrong, _this.props.showCorrectnessFeedback && hasCorrectAnswers && correctAnswers && checked && hasAnswer && !correctAnswers.includes(option.id))),
                "data-option": option.id
              }, html);
            }
          });
        }));
      }
      if (verticalOrHorizontal === 'vertical') {
        var value = _this.getFieldValue();
        var showCorrectAnswers = _this.props.showCorrectnessFeedback && hasCorrectAnswers && hasAnswer;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].verticalBlock
        }, showCorrectAnswers && /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames10["default"])(_style["default"].correctAnswers, _style["default"][verticalWidth])
        }, /*#__PURE__*/_react["default"].createElement("div", null, "Your answer"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].label
        }, "Correct answer", correctAnswers.length > 1 ? 's' : '')), options.map(function (option, index) {
          var _this$_getOptionTypeV = _this._getOptionTypeValue(option),
            allowUserText = _this$_getOptionTypeV.allowUserText,
            userTextPlaceholder = _this$_getOptionTypeV.userTextPlaceholder;
          var checked = value.selected.includes(option.id);
          var isCorrectAnswer = showCorrectAnswers && correctAnswers.includes(option.id);
          return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            key: option.id,
            content: option.label,
            registerAction: _this._registerAction.bind(_assertThisInitialized(_this), index + 1),
            setParameters: _this.props.setParameters,
            accommodations: accommodations,
            allowMasking: true,
            render: function render(_ref5) {
              var html = _ref5.html,
                playAudio = _ref5.playAudio;
              return /*#__PURE__*/_react["default"].createElement("label", {
                onClick: function onClick(event) {
                  event.preventDefault();
                  playAudio();
                  _this.pickOne(option.id);
                },
                className: (0, _classnames10["default"])(_style["default"].option, _style["default"][verticalWidth], _defineProperty(_defineProperty({}, _style["default"].checked, checked), _style["default"].hasCorrectAnswers, showCorrectAnswers)),
                "data-option": option.id
              }, isCorrectAnswer && /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].correctCheckmark
              }, /*#__PURE__*/_react["default"].createElement(_IconCorrect["default"], null)), _this._renderRadioElement(), html, allowUserText && /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].userInput
              }, /*#__PURE__*/_react["default"].createElement("input", {
                type: "text",
                className: "form-control input-sm",
                placeholder: userTextPlaceholder,
                onClick: function onClick(event) {
                  event.stopPropagation();
                  _this.pickOne(option.id, true);
                },
                value: value.userTexts[option.id] || '',
                onChange: _this._onChangeUserText.bind(_assertThisInitialized(_this), option.id)
              })));
            }
          });
        }));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_renderCheckbox", function () {
      var _this$props$settings7 = _this.props.settings,
        verticalOrHorizontal = _this$props$settings7.verticalOrHorizontal,
        showLabelsInMatrixHeader = _this$props$settings7.showLabelsInMatrixHeader,
        verticalWidth = _this$props$settings7.verticalWidth,
        hasCorrectAnswers = _this$props$settings7.hasCorrectAnswers,
        correctAnswers = _this$props$settings7.correctAnswers;
      var accommodations = _objectSpread(_objectSpread({}, _this.props.accommodations), {}, {
        autoplayQuestions: false
      });
      var options = _this._getOptions();
      var correctOptions = _this._getCorrectOptions();
      var hasAnswer = _this.hasAnswer();
      if (_this.props.isMatrixMode && showLabelsInMatrixHeader) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].matrixValuesWrapper
        }, options.map(function (option, index) {
          return /*#__PURE__*/_react["default"].createElement("label", {
            key: option.id,
            className: _style["default"].matrixLabel,
            style: {
              width: "".concat(100 / options.length, "%")
            },
            onClick: function onClick() {
              return _this.pickMultiple(option.id);
            },
            "data-option": option.id
          }, _this._renderBigCheckbox(option), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].hiddenLabel
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: option.label
          })));
        }));
      }
      if (verticalOrHorizontal === 'horizontal') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].horizontalBlock
        }, options.map(function (option, index) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            key: option.id,
            content: option.label,
            registerAction: _this._registerAction.bind(_assertThisInitialized(_this), index + 1),
            setParameters: _this.props.setParameters,
            accommodations: accommodations,
            allowMasking: true,
            render: function render(_ref6) {
              var html = _ref6.html,
                playAudio = _ref6.playAudio;
              return /*#__PURE__*/_react["default"].createElement("div", {
                onClick: function onClick(event) {
                  event.preventDefault();
                  playAudio();
                  _this.pickMultiple(option.id);
                },
                className: (0, _classnames10["default"])(_style["default"].option, _defineProperty(_defineProperty(_defineProperty({}, _style["default"].checked, _this.getFieldValue().selected.includes(option.id)), _style["default"].correct, _this.props.showCorrectnessFeedback && hasCorrectAnswers && hasAnswer && correctOptions.includes(option.id)), _style["default"].wrong, _this.props.showCorrectnessFeedback && hasCorrectAnswers && hasAnswer && !correctOptions.includes(option.id))),
                "data-option": option.id
              }, html);
            }
          });
        }));
      }
      if (verticalOrHorizontal === 'vertical') {
        var value = _this.getFieldValue();
        var showCorrectAnswers = _this.props.showCorrectnessFeedback && hasCorrectAnswers && hasAnswer;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].verticalBlock
        }, showCorrectAnswers && /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames10["default"])(_style["default"].correctAnswers, _style["default"][verticalWidth])
        }, /*#__PURE__*/_react["default"].createElement("div", null, "Your answer", _this.getFieldValue().selected.length > 1 ? 's' : ''), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].label
        }, "Correct answer", correctAnswers.length > 1 ? 's' : '')), options.map(function (option, index) {
          var _this$_getOptionTypeV2 = _this._getOptionTypeValue(option),
            allowUserText = _this$_getOptionTypeV2.allowUserText,
            userTextPlaceholder = _this$_getOptionTypeV2.userTextPlaceholder;
          var isCorrectAnswer = showCorrectAnswers && correctAnswers.includes(option.id);
          return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            key: option.id,
            content: option.label,
            registerAction: _this._registerAction.bind(_assertThisInitialized(_this), index + 1),
            setParameters: _this.props.setParameters,
            accommodations: accommodations,
            allowMasking: true,
            render: function render(_ref7) {
              var html = _ref7.html,
                playAudio = _ref7.playAudio;
              return /*#__PURE__*/_react["default"].createElement("label", {
                onClick: function onClick(event) {
                  event.preventDefault();
                  playAudio();
                  _this.pickMultiple(option.id);
                },
                className: (0, _classnames10["default"])(_style["default"].option, _style["default"][verticalWidth], _defineProperty(_defineProperty({}, _style["default"].checked, _this.getFieldValue().selected.includes(option.id)), _style["default"].hasCorrectAnswers, showCorrectAnswers)),
                "data-option": option.id
              }, isCorrectAnswer && /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].correctCheckmark
              }, /*#__PURE__*/_react["default"].createElement(_IconCorrect["default"], null)), _this._renderCheckboxElement(), html, allowUserText && /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].userInput
              }, /*#__PURE__*/_react["default"].createElement("input", {
                type: "text",
                className: "form-control input-sm",
                placeholder: userTextPlaceholder,
                onClick: function onClick(event) {
                  event.stopPropagation();
                  _this.pickMultiple(option.id, true);
                },
                value: value.userTexts[option.id] || '',
                onChange: _this._onChangeUserText.bind(_assertThisInitialized(_this), option.id)
              })));
            }
          });
        }));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_renderImage", function () {
      var _this$props$settings8 = _this.props.settings,
        singleOrMultiple = _this$props$settings8.singleOrMultiple,
        imageSize = _this$props$settings8.imageSize,
        imagePadding = _this$props$settings8.imagePadding;
      var options = _this._getOptions();
      var accommodations = _objectSpread(_objectSpread({}, _this.props.accommodations), {}, {
        autoplayQuestions: false
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].imageWrapper
      }, options.map(function (option, index) {
        var label = typeof option.label === 'string' ? option.label : option.label.content;
        var title = (0, _cccisdSurveyCommon.stripTags)(label, {
          keepImageAltText: false
        }).trim();
        var imageUrl = label.replace(/^.*<img src="([^"]+)".*$/, '$1');
        return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          key: option.id,
          content: option.label,
          registerAction: _this._registerAction.bind(_assertThisInitialized(_this), index + 1),
          setParameters: _this.props.setParameters,
          accommodations: accommodations,
          render: function render(_ref8) {
            var html = _ref8.html,
              playAudio = _ref8.playAudio;
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: (0, _classnames10["default"])(_style["default"].imageBox, _style["default"]["imageSize".concat((0, _capitalize2["default"])(imageSize))], _defineProperty({}, _style["default"].withPadding, imagePadding))
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: (0, _classnames10["default"])(_style["default"].image, _defineProperty({}, _style["default"].checked, _this.getFieldValue().selected.includes(option.id))),
              onClick: singleOrMultiple === 'single' ? function () {
                playAudio();
                _this.pickOne(option.id);
              } : function () {
                playAudio();
                _this.pickMultiple(option.id);
              },
              style: {
                backgroundImage: "url(".concat(imageUrl, ")")
              },
              "data-option": option.id
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].imageCheckboxWrapper
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].imageCheckbox
            }))), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                display: 'none'
              }
            }, html), title && /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].imageTitle
            }, title));
          }
        });
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderOptions", function () {
      var visualType = _this.props.settings.visualType;
      if (visualType === 'dropdown') {
        return _this._renderDropdown();
      }
      if (visualType === 'button') {
        return _this._renderButton();
      }
      if (visualType === 'radio') {
        return _this._renderRadio();
      }
      if (visualType === 'image') {
        return _this._renderImage();
      }
      if (visualType === 'checkbox') {
        return _this._renderCheckbox();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_isRequired", function () {
      var settings = _this.props.settings;
      if (_this._isSingle()) {
        if (settings.singleAnswerRequired) {
          return true;
        }
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "_isSingle", function () {
      var _this$props$settings9 = _this.props.settings,
        visualType = _this$props$settings9.visualType,
        singleOrMultiple = _this$props$settings9.singleOrMultiple;
      return visualType === 'radio' || visualType === 'dropdown' || visualType === 'button' && singleOrMultiple === 'single' || visualType === 'image' && singleOrMultiple === 'single';
    });
    _defineProperty(_assertThisInitialized(_this), "_onChangeUserText", function (optionId, event) {
      // Return if it is a tree preview
      if (!_this.props.field.onChange) {
        return;
      }
      var prevValue = _this.getFieldValue();

      // Force selecting current choice
      if (_this._isSingle()) {
        prevValue.selected = [optionId];
      } else if (!prevValue.selected.includes(optionId)) {
        prevValue.selected = [].concat(_toConsumableArray(prevValue.selected), [optionId]);
      }
      _this.props.field.onChange(_objectSpread(_objectSpread({}, prevValue), {}, {
        userTexts: _objectSpread(_objectSpread({}, prevValue.userTexts), {}, _defineProperty({}, optionId, event.target.value))
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_getFeedbacks", function () {
      var _this$props$settings10 = _this.props.settings,
        options = _this$props$settings10.options,
        hasCorrectAnswers = _this$props$settings10.hasCorrectAnswers,
        answerFeedbackForOptions = _this$props$settings10.answerFeedbackForOptions,
        correctAnswers = _this$props$settings10.correctAnswers,
        answerFeedbackPositive = _this$props$settings10.answerFeedbackPositive,
        answerFeedbackNegative = _this$props$settings10.answerFeedbackNegative;
      var feedbacks = {
        neutral: [],
        positive: [],
        negative: []
      };
      var value = _this.getFieldValue();
      var optionIds = options.map(function (option) {
        return option.id;
      });
      if (_this._isSingle() || !hasCorrectAnswers) {
        var _iterator2 = _createForOfIteratorHelper(optionIds),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var optionId = _step2.value;
            if (!answerFeedbackForOptions || !answerFeedbackForOptions[optionId] || !value.selected.includes(optionId)) {
              continue;
            }
            if (!hasCorrectAnswers) {
              feedbacks.neutral.push(answerFeedbackForOptions[optionId]);
            } else if (correctAnswers.includes(optionId)) {
              feedbacks.positive.push(answerFeedbackForOptions[optionId]);
            } else {
              feedbacks.negative.push(answerFeedbackForOptions[optionId]);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        var actualCorrectAnswers = (0, _intersection2["default"])(correctAnswers, optionIds);
        var diff = (0, _xor2["default"])(value.selected, actualCorrectAnswers);
        if (diff.length === 0 && answerFeedbackPositive) {
          feedbacks.positive.push(answerFeedbackPositive);
        }
        if (diff.length > 0 && answerFeedbackNegative) {
          feedbacks.negative.push(answerFeedbackNegative);
        }
      }
      return feedbacks;
    });
    return _this;
  }
  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.field.value) {
        this._onChange(this.getFieldValue().selected);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        settings = _this$props2.settings,
        field = _this$props2.field,
        isMatrixMode = _this$props2.isMatrixMode,
        showRequiredState = _this$props2.showRequiredState,
        showQuestionNumbers = _this$props2.showQuestionNumbers,
        startQuestionNumber = _this$props2.startQuestionNumber,
        setParameters = _this$props2.setParameters,
        playerTemplateProps = _this$props2.playerTemplateProps,
        template = _this$props2.template,
        templateExtraProps = _this$props2.templateExtraProps,
        showFeedback = _this$props2.showFeedback,
        showCorrectnessFeedback = _this$props2.showCorrectnessFeedback;
      var elementStyle = (0, _get2["default"])(this.props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
      var accommodations = _objectSpread(_objectSpread({}, this.props.accommodations), {}, {
        autoplayChoices: false
      });
      var feedbackAccommodations = _objectSpread(_objectSpread({}, this.props.accommodations), {}, {
        autoplayQuestions: false
      });
      var feedbacks = this._getFeedbacks();
      var templateProps = _objectSpread({
        question: !isMatrixMode && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.question,
          showRequiredState: showRequiredState && this._isRequired(),
          registerAction: this._registerAction.bind(this, 0),
          setParameters: setParameters,
          accommodations: accommodations,
          prependWith: showQuestionNumbers && "".concat(startQuestionNumber, ". ")
        }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].description
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.description
        }))),
        answer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames10["default"])(_cccisdSurveyCommon.commonStyle.lastRow, _defineProperty({}, _style["default"].disableUserInteractions, showFeedback || showCorrectnessFeedback))
        }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
          field: field,
          showErrorsImmediately: false,
          size: "md"
        }, this._renderOptions())), showFeedback && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, feedbacks.neutral.map(function (feedback, index) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            key: index,
            content: feedback,
            registerAction: _this2._registerAction.bind(_this2, index + 100),
            accommodations: feedbackAccommodations,
            setParameters: _this2.props.setParameters,
            render: function render(_ref9) {
              var html = _ref9.html,
                playAudio = _ref9.playAudio;
              return /*#__PURE__*/_react["default"].createElement("div", {
                className: "alert alert-info",
                style: {
                  margin: '1em 0 0'
                },
                onClick: function onClick() {
                  playAudio();
                }
              }, html);
            }
          });
        }), feedbacks.positive.map(function (feedback, index) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            key: index,
            content: feedback,
            registerAction: _this2._registerAction.bind(_this2, index + 200),
            accommodations: feedbackAccommodations,
            setParameters: _this2.props.setParameters,
            render: function render(_ref10) {
              var html = _ref10.html,
                playAudio = _ref10.playAudio;
              return /*#__PURE__*/_react["default"].createElement("div", {
                className: 'alert alert-success ' + _style["default"].feedback + ' ' + _style["default"].positive,
                style: {
                  margin: '1em 0 0'
                },
                onClick: function onClick() {
                  playAudio();
                }
              }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null), html);
            }
          });
        }), feedbacks.negative.map(function (feedback, index) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            key: index,
            content: feedback,
            registerAction: _this2._registerAction.bind(_this2, index + 300),
            accommodations: feedbackAccommodations,
            setParameters: _this2.props.setParameters,
            render: function render(_ref11) {
              var html = _ref11.html,
                playAudio = _ref11.playAudio;
              return /*#__PURE__*/_react["default"].createElement("div", {
                className: 'alert alert-danger ' + _style["default"].feedback + ' ' + _style["default"].negative,
                style: {
                  margin: '1em 0 0'
                },
                onClick: function onClick() {
                  playAudio();
                }
              }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null), html);
            }
          });
        }))),
        // Advanced props
        settings: settings,
        field: field,
        playerTemplateProps: playerTemplateProps,
        accommodations: accommodations,
        elementStyle: isMatrixMode ? '' : elementStyle
      }, templateExtraProps);
      var Template = template || _defaultTemplate["default"];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].fixIosBug
      }, /*#__PURE__*/_react["default"].createElement(_cccisdResponsive["default"], {
        stylesheet: _style["default"],
        widthBreakpoints: {
          xsmall: 400,
          small: 600,
          medium: 800
        }
      }, /*#__PURE__*/_react["default"].createElement(Template, templateProps)));
    }
  }]);
  return Player;
}(_react["default"].Component);
_defineProperty(Player, "propTypes", {
  settings: _propTypes["default"].object,
  field: _propTypes["default"].object,
  isMatrixMode: _propTypes["default"].bool,
  showRequiredState: _propTypes["default"].bool,
  showQuestionNumbers: _propTypes["default"].bool,
  startQuestionNumber: _propTypes["default"].number,
  template: _propTypes["default"].func,
  templateExtraProps: _propTypes["default"].object,
  playerTemplateProps: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  accommodations: _propTypes["default"].object,
  showFeedback: _propTypes["default"].bool,
  showCorrectnessFeedback: _propTypes["default"].bool
});
_defineProperty(Player, "defaultProps", {
  isMatrixMode: false,
  registerAction: function registerAction() {},
  setParameters: function setParameters() {}
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: _settings.validate
})(Player);